import { useMutation } from '@apollo/client/react';
import { Switch } from 'components/ui';
import { useError } from 'contexts/error';
import { useInfo } from 'contexts/info';
import EditMutation from 'mutations/user/edit';

const EmailNotificationsButton = ({ user, refetch }) => {
  const setError = useError();
  const setInfo = useInfo();

  const [editMutation, { loading }] = useMutation(EditMutation, {
    onCompleted: () => {
      refetch();
      setInfo('info.profile.email_notification_updated');
    },
    onError: () => {
      setError('error.user.profile.edit');
    },
  });

  const handleChange = (event) => {
    editMutation({ variables: { emailNotifications: event.target.checked } });
  };

  return <Switch checked={!!user.emailNotifications} onChange={handleChange} disabled={loading} />;
};

export default EmailNotificationsButton;
